import React, { Component } from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { Notify } from "../../../Helpers/notification.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';

class ReportScheduleLogs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reportScheduleLogsList: [],
            apiPath: props.app.apiPath,
            role: props.app.role,
            userId: props.app.userId,
            noDataDisplayMsg: '',
            sizePerPage: 10,
            addReportScheduleModel: false,
            reportParamsList:[],
            selectedReportParams:[],
            selectedFrequency:'',
            loggedInUser:''
        }
        document.title = 'Report Scheduling Logs'

    }

    componentDidMount() {
        const selectedScheduleId = this.props.selectedScheduleId
        const savedSizePerPage = 10
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
        const apiPath = this.props.app.apiPath;
        Fetcher.get(apiPath + '/api/obd/report/schedule/'+selectedScheduleId +'/logs',)
            .then(res => {
                this.setState({
                    reportScheduleLogsList: res,
                })
            })
            .catch(err => { console.log('Error in fetching Report Schedule', err) });
    }

    setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }


    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('callDetailRecordListsizePerPage', newSizePerPage);
    }

    render() {

        const reportScheduleLogsList = this.state.reportScheduleLogsList;
        const columns = [
            {
                dataField: 'reportScheduleId',
                text: 'Report Schedule Id',
                sort: true,
                hidden: false
            },
            {
                dataField: 'frequency',
                text: 'Frequency',
                sort: true,
                hidden: false
            },
            {
                dataField: 'status',
                text: 'Status',
                sort: false,
                hidden: false
            },
            {
                dataField: 'errorMessage',
                text: 'ErrorMessage',
                sort: false,
                hidden: false
            },
            {
                dataField: 'sentAt',
                text: 'Sent At',
                sort: false,
                hidden: false
            },
            {
                dataField: 'createdAt',
                text: 'Created At',
                sort: false,
                hidden: false
            },
        ];

        const records = Array.isArray(reportScheduleLogsList) ? reportScheduleLogsList.map((row, index) => {
            return {
                reportScheduleId: row.reportScheduleId,
                frequency: row.frequency,
                status: row.status,
                errorMessage:row.errorMessage,
                sentAt: row.sentAt,
                createdAt: row.createdAt,
            };
        }) : []

        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'reqDate',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: records.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <>
            <Card>
                <Card.Header>Report Scheduling Logs</Card.Header>
                <Card.Body>
                    <div className="widget-list-table-cont">
                        <br/>

                        <PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {({
                                paginationProps, paginationTableProps
                            }) => (
                                <ToolkitProvider
                                    keyField="reqDate"
                                    data={records}
                                    columns={columns}
                                    search
                                    bootstrap4
                                >
                                    {
                                        props => (
                                            <div className="">
                                                Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                                <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                                <ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
                                                <Button
                                                    id="refresh"
                                                    type="button"
                                                    className="float-right btn btn-default btn-primary ml-2"
                                                    onClick={() =>
                                                        window.location.href = `${this.props.app.urlPrefix}/report-scheduling`
                                                    }
                                                >
                                                    🡰 Back
                                                </Button>
                                                <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.refreshPage()}>Refresh</Button>
                                                <hr />
                                                <BootstrapTable defaultSorted={defaultSorted} bordered={true} striped={true} condensed wrapperClasses="table-responsive" classes="widgetlist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={this.state.noDataDisplayMsg} />
                                                <PaginationListStandalone {...paginationProps} />
                                            </div>
                                        )}
                                </ToolkitProvider>
                            )}
                        </PaginationProvider>
                    </div>

                </Card.Body>
            </Card>
        </>

        );
    }
}

export default ReportScheduleLogs;